// extracted by mini-css-extract-plugin
export default {"container":"radio-selector_container__RG4z2","option":"radio-selector_option__TkglF"};